import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './Sidebar.module.css'

interface SidebarProps {
  activeItem?: string
}

export default function Sidebar({ activeItem = 'home' }: SidebarProps) {
  const [hoveredItem, setHoveredItem] = useState<string | null>(null)
  const navigate = useNavigate()

  const navigationItems = [
    { id: 'home', label: 'Home', path: '/' },
    { id: 'recently-added', label: 'Recently Added', path: '/recently-added' },
    { id: '1', label: 'Product Designs', path: '/collection/1' },
    { id: '2', label: 'Saved Docs', path: '/collection/2' },
    { id: '3', label: 'Drawings', path: '/collection/3' },
    { id: '4', label: 'Outdoors', path: '/collection/4' },
    { id: '5', label: 'Renovating', path: '/collection/5' },
    { id: '6', label: 'UX', path: '/collection/6' },
    { id: 'other', label: 'Other', path: '/files' }
  ]

  const handleNavigation = (path: string) => {
    navigate(path)
  }

  return (
    <aside className={styles.sidebar}>
      <nav className={styles.sidebarNav}>
        {navigationItems.map((item) => {
          const isActive = item.id === activeItem
          const shouldShowLabel = isActive || hoveredItem === item.id
          
          return (
            <div
              key={item.id}
              className={`${styles.sidebarItem} ${isActive ? styles.sidebarItemActive : ''}`}
              onMouseEnter={() => setHoveredItem(item.id)}
              onMouseLeave={() => setHoveredItem(null)}
              onFocus={() => setHoveredItem(item.id)}
              onBlur={() => setHoveredItem(null)}
              onClick={() => handleNavigation(item.path)}
              tabIndex={0}
            >
              <div className={styles.sidebarNavElement}>
                <div className={styles.sidebarLine}></div>
                {shouldShowLabel && (
                  <div className={styles.sidebarLabel}>
                    {item.label}
                  </div>
                )}
              </div>
            </div>
          )
        })}
      </nav>
    </aside>
  )
}